import { render } from "./PhoneInput.vue?vue&type=template&id=0ab8990b&scoped=true"
import script from "./PhoneInput.vue?vue&type=script&lang=js"
export * from "./PhoneInput.vue?vue&type=script&lang=js"

import "./PhoneInput.vue?vue&type=style&index=0&id=0ab8990b&scoped=true&lang=scss"

import exportComponent from "/builds/swift-dental/my-swift-dental/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ab8990b"]])

export default __exports__